import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function Simple(_a) {
    var message = _a.message;
    return _jsx("p", { className: "message", children: message });
}
